// SVGs for waypoint type
import locationSVG from '@/assets/icons/waypoint-type/default.svg?raw'
import accessSVG from '@/assets/icons/waypoint-type/access-point.svg?raw'
import atvSVG from '@/assets/icons/waypoint-type/atv.svg?raw'
import bearSVG from '@/assets/icons/waypoint-type/bear.svg?raw'
import bikeSVG from '@/assets/icons/waypoint-type/bike.svg?raw'
import boatRampSVG from '@/assets/icons/waypoint-type/boat-ramp.svg?raw'
import cabinSVG from '@/assets/icons/waypoint-type/cabin.svg?raw'
import campBackcountrySVG from '@/assets/icons/waypoint-type/camp-backcountry.svg?raw'
import canoeSVG from '@/assets/icons/waypoint-type/canoe.svg?raw'
import eagleSVG from '@/assets/icons/waypoint-type/eagle.svg?raw'
import fishSVG from '@/assets/icons/waypoint-type/fish.svg?raw'
import fishingSVG from '@/assets/icons/waypoint-type/fishing.svg?raw'
import gateSVG from '@/assets/icons/waypoint-type/gate.svg?raw'
import gearSVG from '@/assets/icons/waypoint-type/gear.svg?raw'
import handLaunchSVG from '@/assets/icons/waypoint-type/hand-launch.svg?raw'
import hazardSVG from '@/assets/icons/waypoint-type/hazard.svg?raw'
import hikerSVG from '@/assets/icons/waypoint-type/hiker.svg?raw'
import horsebackSVG from '@/assets/icons/waypoint-type/horseback.svg?raw'
import houseSVG from '@/assets/icons/waypoint-type/house.svg?raw'
import fourXFourSVG from '@/assets/icons/waypoint-type/4x4.svg?raw'
import kayakSVG from '@/assets/icons/waypoint-type/kayak.svg?raw'
import lighthousesSVG from '@/assets/icons/waypoint-type/lighthouses.svg?raw'
import logObstacleSVG from '@/assets/icons/waypoint-type/log-obstacle.svg?raw'
import parkingSVG from '@/assets/icons/waypoint-type/parking.svg?raw'
import photoSVG from '@/assets/icons/waypoint-type/photo.svg?raw'
import rapidsSVG from '@/assets/icons/waypoint-type/rapids.svg?raw'
import sasquatchSVG from '@/assets/icons/waypoint-type/sasquatch.svg?raw'
import snowmobileSVG from '@/assets/icons/waypoint-type/snowmobile.svg?raw'
import swimmingSVG from '@/assets/icons/waypoint-type/swimming.svg?raw'
import trailSVG from '@/assets/icons/waypoint-type/trail.svg?raw'
import truckSVG from '@/assets/icons/waypoint-type/truck.svg?raw'
import turnHereSVG from '@/assets/icons/waypoint-type/turn-here.svg?raw'
import wetlandSVG from '@/assets/icons/waypoint-type/wetland.svg?raw'

import whiteBassSVG from '@/assets/icons/waypoint-type/white-bass.svg?raw'
import walleyeSVG from '@/assets/icons/waypoint-type/walleye.svg?raw'
import smallmouthBassSVG from '@/assets/icons/waypoint-type/smallmouth-bass.svg?raw'
import saugerSVG from '@/assets/icons/waypoint-type/sauger.svg?raw'
import rockBassSVG from '@/assets/icons/waypoint-type/rock-bass.svg?raw'
import troutSVG from '@/assets/icons/waypoint-type/trout.svg?raw'
import pumpkinseedSVG from '@/assets/icons/waypoint-type/pumpkinseed.svg?raw'
import perchSVG from '@/assets/icons/waypoint-type/perch.svg?raw'
import pikeSVG from '@/assets/icons/waypoint-type/pike.svg?raw'
import muskieSVG from '@/assets/icons/waypoint-type/muskie.svg?raw'
import largemouthBassSVG from '@/assets/icons/waypoint-type/largemouth-bass.svg?raw'
import flatheadCatfishSVG from '@/assets/icons/waypoint-type/flathead-catfish.svg?raw'
import crappieSVG from '@/assets/icons/waypoint-type/crappie.svg?raw'
import salmonSVG from '@/assets/icons/waypoint-type/salmon.svg?raw'
import channelCatfishSVG from '@/assets/icons/waypoint-type/channel-catfish.svg?raw'
import bluegillSVG from '@/assets/icons/waypoint-type/bluegill.svg?raw'
import blueCatfishSVG from '@/assets/icons/waypoint-type/blue-catfish.svg?raw'

/** Specialty icons that should not be shown in waypoint type selectors **/
const SPECIALTY_ICONS = ['Leupold', 'Sig Sauer', 'Horus', 'Revic', 'Leica']

/**
 * Utility class for dealing with icons
 */
class Icons {
  /**
   * Pull the appropriate waypoint SVG icon set for the loaded app
   *
   * @return {object} Hash of waypoint icons
   */
  getAppIconSet() {
    return {
      '4x4': fourXFourSVG,
      'Access Point': accessSVG,
      ATV: atvSVG,
      Bear: bearSVG,
      Bike: bikeSVG,
      'Boat Ramp': boatRampSVG,
      Cabin: cabinSVG,
      Camp: campBackcountrySVG,
      Canoe: canoeSVG,
      Eagle: eagleSVG,
      Fish: fishSVG,
      Fishing: fishingSVG,
      Gate: gateSVG,
      Gear: gearSVG,
      'Hand Launch': handLaunchSVG,
      Hazard: hazardSVG,
      Hike: hikerSVG,
      Horseback: horsebackSVG,
      House: houseSVG,
      Kayak: kayakSVG,
      Lighthouse: lighthousesSVG,
      Location: locationSVG,
      'Log Obstacle': logObstacleSVG,
      Parking: parkingSVG,
      Photo: photoSVG,
      Rapids: rapidsSVG,
      Sasquatch: sasquatchSVG,
      Snowmobile: snowmobileSVG,
      Swimming: swimmingSVG,
      Trailhead: trailSVG,
      Truck: truckSVG,
      'Turn Here': turnHereSVG,
      Wetland: wetlandSVG,
      'White Bass': whiteBassSVG,
      Walleye: walleyeSVG,
      'Smallmouth Bass': smallmouthBassSVG,
      Sauger: saugerSVG,
      'Rock Bass': rockBassSVG,
      Trout: troutSVG,
      Pumpkinseed: pumpkinseedSVG,
      Perch: perchSVG,
      Pike: pikeSVG,
      Muskie: muskieSVG,
      'Largemouth Bass': largemouthBassSVG,
      'Flathead Catfish': flatheadCatfishSVG,
      Crappie: crappieSVG,
      Salmon: salmonSVG,
      'Channel Catfish': channelCatfishSVG,
      Bluegill: bluegillSVG,
      'Blue Catfish': blueCatfishSVG,
    }
  }

  /**
   * Transform waypoint data for the selector form element
   *
   * @param {string} toSelect - Icon which should be set as selected
   * @return {array} Array of waypoint icons ready for icon selector template
   */
  getWaypointSelectorIcons(toSelect) {
    const selectorIcons = []
    const iconSet = this.getAppIconSet()
    for (const name in iconSet) {
      if (SPECIALTY_ICONS.includes(name)) {
        continue
      }

      selectorIcons.push(this.getIconFromName(name, iconSet, toSelect))
    }
    return selectorIcons.sort((a, b) => a.label.localeCompare(b.label))
  }

  /**
   * Calculate the most recently used icon list
   *
   * @param {array} waypoints - an array of all the waypoints
   * @param {object} icon - selected icon
   * @return {Array} Array of waypoint icons
   */
  calculateRecentlyUsedIcons(waypoints, toSelect) {
    const iconSet = this.getAppIconSet()

    if (waypoints?.length > 0) {
      const waypointsSorted = waypoints
        .sort((a, b) => {
          // sort by recently used
          return b.updatedAt.getTime() - a.updatedAt.getTime()
        })
        .filter((waypoint) => {
          // filter out unknown icons and currently selected icon
          const icon = waypoint.properties?.icon
          return (
            icon &&
            !!iconSet[icon] &&
            icon !== toSelect &&
            !SPECIALTY_ICONS.includes(icon)
          )
        })

      // use a set to enforce uniqueness, pull out the icon names
      const recentIconNames = [
        ...new Set(waypointsSorted.map((x) => x.properties?.icon)),
      ].slice(0, 8)

      // get the icon data for the recent names
      return recentIconNames.map((name) =>
        this.getIconFromName(name, iconSet, toSelect)
      )
    }

    return []
  }

  /**
   * Get icon based on the name. If no icon for this name is found, set
   * the icon to the location icon.
   *
   * @param {string} name - the name of the icon
   * @param {array} iconSet - icons based on the app
   * @param {string} toSelect - name of icon to set selected on
   * @return {object} icon
   */
  getIconFromName(name, iconSet, toSelect) {
    return {
      icon: iconSet[name] || iconSet['Location'],
      label: name,
      className: name.toLowerCase().replace(/(\s|\/)/gi, '-'),
      selected: name === toSelect,
    }
  }
}

const icons = new Icons()
export default icons
